/// <amd-module name="CodeCoverage/ViewCommon/RunViewArtifact" />
import { Build } from "Build/Client/Contracts/Build";

interface IRunViewArtifact {
    buildId: number;
    projectId: string;
    sourceBranch: string;
    sourceRepositoryId: string;
    sourceRepositoryType: string;
    sourceVersion: string;
}

export class RunViewArtifact implements IRunViewArtifact {
    public static GetArtifactDataFromBuild(build: Build): RunViewArtifact {
        return new RunViewArtifact(
            build.id,
            build.project.id,
            build.sourceBranch,
            build.repository.id,
            build.repository.type,
            build.sourceVersion,
            build.finishTime
        );
    }

    public readonly buildId: number;
    public readonly projectId: string;
    public readonly sourceBranch: string;
    public readonly sourceRepositoryId: string;
    public readonly sourceRepositoryType: string;
    public readonly sourceVersion: string;
    public readonly finishTime: Date;

    public constructor(
        buildId: number,
        projectId: string,
        sourceBranch: string,
        sourceRepositoryId: string,
        sourceRepositoryType: string,
        sourceVersion: string,
        finishTime: Date
    ) {
        this.buildId = buildId;
        this.projectId = projectId;
        this.sourceBranch = sourceBranch;
        this.sourceRepositoryId = sourceRepositoryId;
        this.sourceRepositoryType = sourceRepositoryType;
        this.sourceVersion = sourceVersion;
        this.finishTime = finishTime;
    }
}
